import request from '@/utils/request';
import { fileService } from "@/api/common/file-utils";
export default {
    // 获取报告维护频率
    getReportFreqOptions: () => {
        return request({
            url: `/rmc/protein/medicineUsage/reportFreqOptions`,
            method: "get",
        });
    },
    // getSelector: (param) => {
    // 获取报告期限
    //     return request({
    //         url: `/rmc/protein/medicineUsage/getSelector`,
    //         method: 'post',
    //     });
    // },
    // 获取报告期限
    getReportDateOptions: (reportFreq) => {
        return request({
            url: `/rmc/protein/medicineUsage/getReportDateOptions`,
            method: 'get',
            params: {
                reportFreq: reportFreq,
            },
        });
    },
    // 获取屠宰场下拉值
    getProteinAslLists: (aslGroup, category) => {
        return request({
            url: `/rmc/protein/asl/aslOptions`,
            method: "get",
            params: {
                aslGroup: aslGroup,
                category: category,
            },
        });
    },
    // 获取农场名称下拉值
    getFarmOptions: (aslGroup, category) => {
        return request({
            url: `/rmc/protein/farm/farmOptions`,
            method: "get",
            params: {
                aslGroup: aslGroup,
                category: category
            },
        });
    },
    // 药品用量查询
    getMedicineUsage: (param) => {
        return request({
            url: `/rmc/protein/medicineUsage/queryPage`,
            method: 'post',
            data: param
        });
    },
    // 整单导入药品用量
    uploadMedicineUsage: (param) => {
        return request({
            url: `/rmc/protein/medicineUsage/upload`,
            method: 'post',
            data: param
        });
    },
    // 批量导入出栏信息
    uploadCropRate: (param) => {
        return request({
            url: `/rmc/protein/medicineUsage/uploadCropRate`,
            method: 'post',
            data: param
        });
    },
    // 详情页面保存
    saveMedicineUsage: (param) => {
        return request({
            url: `/rmc/protein/medicineUsage/save`,
            method: 'post',
            data: param
        });
    },
    // 提交
    submitMedicineUsage: (param) => {
        return request({
            url: `/rmc/protein/medicineUsage/submit`,
            method: 'post',
            data: param
        });
    },
    // 查询详情
    medicineUsageDetail: (id) => {
        return request({
            url: `/rmc/protein/medicineUsage/queryDetail/${id}`,
            method: 'post',
        });
    },
    // 删除出栏信息
    deleteCropRate: (param) => {
        return request({
            url: `/rmc/protein/medicineUsage/deleteCropRate`,
            method: 'post',
            data: param
        });
    },
    // 删除
    deleteMedicineUsage: (param) => {
        return request({
            url: `/rmc/protein/medicineUsage/delete`,
            method: 'post',
            data: param
        });
    },
    // 保存药品用量行项目
    saveAmount: (param) => {
        return request({
            url: `/rmc/protein/medicineUsage/saveAmount`,
            method: 'post',
            data: param
        });
    },
    // 保存出栏信息行项目
    saveCropRate: (param) => {
        return request({
            url: `/rmc/protein/medicineUsage/saveCropRate`,
            method: 'post',
            data: param
        });
    },
    // 删除药品用量行项目
    deleteAmount: (param) => {
        return request({
            url: `/rmc/protein/medicineUsage/deleteAmount`,
            method: 'post',
            data: param
        });
    },
    // 导出
    exportMedicineUsage: (param) => {
        return request({
            url: `/rmc/protein/medicineUsage/exportMedicineUsage`,
            method: 'post',
            data: param,
            responseType: "blob",
            fullResponse: true,
        });
    },

    // 下载整单导入模板
    downloadImportTemplate: () => request({
        url: '/rmc/protein/medicineUsage/downloadUploadTemplate',
        method: 'get',
        fullResponse: true,
        responseType: 'blob',
    }).then(resp => {
        fileService.respToFile(resp, '药品用量-Poultry整单导入模板.xlsx');
    }),
    // 下载出栏信息批量导入模板
    downloadUploadCropRateTemplate: (param) => request({
        url: '/rmc/protein/medicineUsage/downloadUploadCropRateTemplate',
        method: 'post',
        data: param,
        fullResponse: true,
        responseType: 'blob',
    }).then(resp => {
        fileService.respToFile(resp, 'protein药品用量行明细导入报表.xlsx');
    }),
    // 操作日志
    getOperationLog: (id) => {
        return request({
            url: `/rmc/protein/medicineUsage/operationLog/${id}`,
            method: 'get',
        });
    },
    // 获取统计图表的数据
    getSummaryEchart: (id) => {
        return request({
            url: `/rmc/protein/medicineUsage/farmLevelUsageDetails/${id}`,
            method: 'get',
        });
    },
    // 统计图表导出
    downloadFile: (id) => {
        return request({
            url: `/rmc/protein/medicineUsage/downloadFarmLevelUsageDetails/${id}`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            params: {},
            fullResponse: true,
            responseType: 'blob',
        })
    },
    // 获取养殖模式
    getBreedingModeList: () => {
        return request({
            url: "/rmc/protein/medicineUsage/breedingModeList",
            method: 'get'
        })
}
}